import * as React from 'react';
import {CSSProperties} from 'react';
import AccountingNote from "../../../../model/invoice/note/AccountingNote";
import {RouteComponentProps, withRouter} from "react-router";
import {default as CommonStreamItem} from "../../../../hiberUiKit/src/molecules/StreamItem/CommonStreamItem";
import {RootState} from "../../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import {api} from "../../../../api/api";
import Toast from "../../../helper/Toast";
import {notifyBugsnagAndShowToast} from "../../../../utils/Utils";

interface ReduxProps {
	/**
	 * Logged user id
	 */
	loggedUserId: string
}

interface ComponentProps {
	/**
	 * Bill activity to display.
	 */
	activity: AccountingNote;
	/**
	 * Indicates if history item is active.
	 */
	isActive: boolean;
	/**
	 * On edit note click.
	 * @param {AccountingNote} note to edit.
	 */
	onEditNoteClick?: (note: AccountingNote) => void;
	/**
	 * On delete note success callback.
	 * @param {AccountingNote} note deleted note.
	 */
	onDeleteNoteSuccess?: (note: AccountingNote) => void;
	/**
	 * Indicates if action are disabled
	 */
	readOnly?: boolean
}

interface RouteProps {
	billId: string
}

type Props = ComponentProps & ReduxProps & RouteComponentProps<RouteProps>;

class BillActivityNoteItem extends React.Component<Props, {}> {
	/**
	 * Indicates if user can edit and delete this note.
	 */
	editable: boolean;
	/**
	 * Activity item container style.
	 */
	containerStyle: CSSProperties;

	constructor(props: Props) {
		super(props);
		this.editable = props.activity.creator.id === props.loggedUserId && !props.readOnly;
		this.editNoteClick = this.editNoteClick.bind(this);
		this.onDeleteNoteSuccess = this.onDeleteNoteSuccess.bind(this);
		this.deleteNoteClick = this.editable ? this.deleteNoteClick.bind(this) : undefined;
		this.containerStyle = {cursor: this.editable ? "pointer" : "auto"};
	}

	render() {
		return (
			<div onClick={this.editNoteClick} style={this.containerStyle}>
				<CommonStreamItem event={this.props.activity}
								  onDeleteClick={this.deleteNoteClick}/>
			</div>
		);
	}

	deleteNoteClick() {
		api.instance.noteApi.deleteBillNote(this.props.activity.id)
			.then(this.onDeleteNoteSuccess)
			.catch((error) => notifyBugsnagAndShowToast(error, "Delete note"));
	}

	onDeleteNoteSuccess() {
		Toast.success("Note has been deleted", "Delete note");
		this.props.onDeleteNoteSuccess && this.props.onDeleteNoteSuccess(this.props.activity);
	}

	editNoteClick() {
		(this.editable && this.props.onEditNoteClick) && this.props.onEditNoteClick(this.props.activity);
	}
}

function mapStateToProps(state: RootState) {
	return {loggedUserId: state.user.user.get.id}
}

export default withRouter<ComponentProps>(connect(mapStateToProps)(BillActivityNoteItem));